const ReconDashboard = () =>
  import('../screens/FinanceReconTool/ReconDashboard/ReconDashboard.vue');
const ReconFinancialRecords = () =>
  import('../screens/FinanceReconTool/ReconFinancialRecords/FinancialRecords.vue');
const ReconUnparsedRecords = () =>
  import('../screens/FinanceReconTool/ReconUnparsedRecords/UnparsedRecords.vue');

export default [
  {
    component: ReconDashboard,
    meta: {
      activeSidebarItemId: 'recon-dashboard',
      authority: 'recon_tool:view',
      pageTitle: 'Recon Tool',
    },
    name: 'recon-dashboard',
    path: '/recon-dashboard',
  },
  {
    component: ReconFinancialRecords,
    meta: {
      activeSidebarItemId: 'recon-financial-records',
      authority: 'bank_statement_transactions:view',
      pageTitle: 'Reconciliation Financial Records',
    },
    name: 'recon-financial-records',
    path: '/recon-financial-records',
  },
  {
    component: ReconUnparsedRecords,
    meta: {
      activeSidebarItemId: 'recon-unparsed-records',
      pageTitle: 'Reconciliation Unparsed Records',
    },
    name: 'recon-unparsed-records',
    path: '/recon-unparsed-records',
  },
];
